import { ulid } from 'ulid'

export default class AppError {
  id: string = ulid()
  error: Error | null = null
}
